import { createApp } from 'vue';
// import TrioAssets from 'trio-assets-js';

// Styles.
import './scss/app.scss';

// Scripts.
// utils
import { smoothScrollViewport } from './js/utils/smooth-scroll';
// elements
import './js/elements/accordion';
import './js/elements/ar-download';
import './js/elements/backlink';
import './js/elements/image-slider';
import './js/elements/on-scroll';
import './js/elements/related-content';
import './js/elements/scroll-to-element';
import './js/elements/table';
import './js/elements/tabs';
import './js/elements/video';

// navigation
import './js/navigation/main-nav';

// paragraphs

// Vue components.
import TargetNumbers from '~/js/components/TargetNumbers';
import TargetNumbersTab from '~/js/components/TargetNumbersTab';

(() => {
  smoothScrollViewport();
  // Init a small Vue app for the front page target numbers carousel.
  const frontPageNumbersCarousel = document.querySelector(
    '.front-page-target-numbers__carousel',
  );

  if (frontPageNumbersCarousel) {
    const app = createApp({
      data() {
        return {};
      },
    });

    // Note: we can register components in camel case but due to caveats of
    // in-DOM template parsing, kebab case should be used in Twig markup.
    // See https://vuejs.org/guide/essentials/component-basics.html#in-dom-template-parsing-caveats.
    app.component('TargetNumbers', TargetNumbers);
    app.component('TargetNumbersTab', TargetNumbersTab);
    app.mount(frontPageNumbersCarousel);
  }
})();
